import SectionHeading from "./section-heading";

export default function Clients() {
  const logos = Array.from({ length: 12 }, (_, i) => `/logos/${i + 1}.png`);

  return (
    <div className="bg-white pt-[12px] sm:pt-[16px] md:pt-[20px] pb-6 sm:pb-10 w-full overflow-hidden px-4 sm:px-0">
      {/* Section heading */}
      <SectionHeading>
        <span className="text-[23px] sm:text-[24px] md:text-[40px]">
          Our Clients
        </span>
      </SectionHeading>

      {/* Marquee container */}
      <div className="mt-4 sm:mt-6 md:mt-8 w-full overflow-hidden relative">
        <div
          className="flex whitespace-nowrap items-center w-max will-change-transform
            animate-marquee"
        >
          {/* First copy */}
          {logos.map((src, idx) => (
            <div
              key={`logo1-${idx}`}
              className="shrink-0 flex items-center justify-center mx-8 sm:mx-12 md:mx-16"
            >
              <img
                src={src}
                alt={`Client logo ${idx + 1}`}
                className="h-10 sm:h-12 md:h-14 w-auto object-contain brightness-100 contrast-110"
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}

          {/* Second copy (duplicate for seamless loop) */}
          {logos.map((src, idx) => (
            <div
              key={`logo2-${idx}`}
              className="shrink-0 flex items-center justify-center mx-8 sm:mx-12 md:mx-16"
            >
              <img
                src={src}
                alt={`Client logo ${idx + 1}`}
                className="h-10 sm:h-12 md:h-14 w-auto object-contain brightness-100 contrast-110"
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Animation Keyframes */}
      <style jsx>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-marquee {
          animation: marquee 25s linear infinite;
        }
      `}</style>
    </div>
  );
}
